import SignatureBox from "../components/SignatureBox.svelte";

// usage <div data-signature-box data-signature-box-name="FormPropertyName" data-signature-box-id="elementId" data-signature-box-class="canvasClass"></div>
document.querySelectorAll("[data-signature-box]").forEach((target) => {
  new SignatureBox({
    target,
    props: {
      class: target.getAttribute("data-signature-box-class"),
      id: target.getAttribute("data-signature-box-id"),
      name: target.getAttribute("data-signature-box-name"),
      value: target.getAttribute("data-signature-box-value"),
    },
  });
});
